export default __webpack_public_path__ + "static/media/arrow_up.694da2e3.svg";